import React from "react";
import { shallowEqual } from "react-redux";
import UscBasketItemWrapper from "./common/UscBasketItemWrapper";
import { useUscLabel } from "../../../../utils/labels";
import { getFeeListSelector } from "../../../../utils/externalPriceUtils";
import DisclaimerIconWrapper from "../DisclaimerIconWrapper";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import Text from "../../styles/atoms/Text";
import { useUscSelector } from "../../../../redux/store";
import TaxLocation from "../TaxLocation";
import { UscTrackingLocation } from "../../../../utils/tracking";

type Props = { feeType: "included" | "excluded" };
const UscBasketFees = ({ feeType }: Props): JSX.Element | null => {
    const feeList = useUscSelector(getFeeListSelector(feeType), shallowEqual);
    const includedTaxesAndCostsLabel = useUscLabel("uscTaxesAndCostsTitle");
    const isIncluded = feeType === "included";

    if (!feeList.length) return null;

    return (
        <div>
            <UscBasketItemWrapper title={isIncluded ? includedTaxesAndCostsLabel : ""}>
                {isIncluded && <TaxLocation trackingLocation={UscTrackingLocation.BasketDetails} />}
                {feeList.map((tax) => (
                    <li key={tax.key}>
                        <Text variant="paragraph-small-book" color="midnight">
                            {tax.label}
                            {!!tax.disclaimer && (
                                <DisclaimerIconWrapper type={UscDisclaimerType.ExternalPrice} reference={tax.key} />
                            )}
                        </Text>
                        <Text variant="paragraph-small-book" color="midnight">
                            <span dangerouslySetInnerHTML={{ __html: tax.formattedPrice }} />
                        </Text>
                    </li>
                ))}
            </UscBasketItemWrapper>
        </div>
    );
};

export default UscBasketFees;
